import { Injectable, inject } from '@angular/core';
import { BudgetOptions } from '../../../../../core/constants-repository/project-calculation.constants';
import { ProjectModel } from '../../../../../core/models/project/project.model';
import { DateTimeHelper } from '../../../../../features/calendar/util/date-time-helper';
import { LineChartData } from '../../../../../shared/data-types/chart-types';
import { TimeBlockWithTask } from '../../../../../shared/data-types/shared-time-block-types';
import { Interval } from 'date-fns';
import { ExpenditureCalculationService } from '../../project-edit/manage-project/project-calculation-form/services/expenditure-calculation.service';

@Injectable({
  providedIn: 'root',
})
export class ProjectBudgetChartTransformerService {
  private readonly expenditureCalculationService = inject(ExpenditureCalculationService);

  public transformFeesToChartData(
    project: ProjectModel,
    startOfView: Date,
    endOfView: Date,
    timeBlocks: readonly TimeBlockWithTask[],
  ): LineChartData[] {
    if (project.budgetType === BudgetOptions.NoBudget) {
      return [];
    }
    const timeBlockFeeMap = this.expenditureCalculationService.calcExpenditurePerDay(
      project,
      timeBlocks,
      {
        start: null,
        end: endOfView,
      },
    );

    // Accumulate values in the map.
    const filledTimeBlockFeeMap = this.fillMap(timeBlockFeeMap, {
      start: startOfView,
      end: endOfView,
    });

    // And finally transform the map to a LineChart array.
    return Array.from(filledTimeBlockFeeMap, ([date, value]) => ({
      date: new Date(date),
      value,
    }));
  }

  private fillMap(timeBlockFeeMap: Map<string, number>, range: Interval): Map<string, number> {
    const updatedMap = new Map<string, number>();
    DateTimeHelper.eachDayOfInterval(range.start as Date, range.end as Date).forEach((date) => {
      const prevDay = DateTimeHelper.subDays(date, 1);

      const curDateString = DateTimeHelper.format(date);
      const prevDateString = DateTimeHelper.format(prevDay);

      const curValue = timeBlockFeeMap.get(curDateString) ?? 0;
      const prevSum = updatedMap.get(prevDateString) ?? timeBlockFeeMap.get(prevDateString) ?? 0;

      const total = prevSum + curValue;
      updatedMap.set(curDateString, total);
    });
    return updatedMap;
  }
}
